'use client';

import { Icons } from '@/components/Shares/Icons';
import modalStyle from '@/components/Shares/Modal.module.css';
import classes from '@/components/Shares/Tab.module.css';
import { DepositProvider } from '@/providers/DepositProvider';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { WithdrawProvider } from '@/providers/WithdrawProvider';
import { Box, Flex, Group, Image, Modal, Tabs } from '@mantine/core';
import { Coupons } from './Coupons';
import { Deposit } from './Deposit';
import { Referrals } from './Referrals';
import { Wallet } from './WalletTab';
import { WalletTabControl } from './WalletTabControl';
import { Withdraw } from './Withdraw';
export const WalletModal: React.FC = () => {
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  return <Modal opened={openModal === MODAL.WALLET} onClose={() => setOpenModal(null)} closeButtonProps={{
    size: 37,
    bg: 'transparent',
    icon: <Icons className="icon-pr-line-close" fontSize={37} />
  }} overlayProps={{
    bg: 'rgba(23, 26, 30, 0.95)'
  }} size="100%" classNames={modalStyle}>
      <Group pos="absolute" bottom={0} left={0} right={0} justify="center">
        <Image src="/assets/bottom-character.svg" alt="character" w={{
        base: 256,
        md: 350,
        lg: 357
      }} h={{
        base: 182,
        md: 250,
        lg: 254
      }} />
      </Group>
      <Flex justify="center" w="100%" pb={{
      base: 182,
      md: 250,
      lg: 254
    }}>
        <Flex w={{
        base: '100%',
        sm: 722,
        lg: 874
      }} mb={50}>
          <Tabs defaultValue="wallet" variant="pills" w="100%" classNames={classes}>
            <WalletTabControl />

            <Box mt={{
            base: 16,
            sm: 20
          }}>
              <Wallet />

              <DepositProvider>
                <Deposit />
              </DepositProvider>

              <WithdrawProvider>
                <Withdraw />
              </WithdrawProvider>

              <Coupons />

              <Referrals />
            </Box>
          </Tabs>
        </Flex>
      </Flex>
    </Modal>;
};